import { ApiResponse } from "types/apiTypes";
import axios from "./axiosInstance";

export const getClassLevels = async () => {
  const response = await axios.get("/reference/class-levels");
  return response.data;
};


export const getLeaveTypes = async () => {
    const response = await axios.get<ApiResponse<any>> ("/reference/leave-types");
    return response?.data?.data;
};

export const getJobPositions = async () => {
    const response = await axios.get<ApiResponse<any>> ("/reference/job-positions");
    return response?.data?.data;
};




